.detail {
	display: flex;
	flex-direction: column;
	min-block-size: 0;
	padding-block-start: var(--spacing-4);

	/* Sit the header flush at the top of the content pane, matching the board's
	   full-bleed command band (which the boot skeleton renders), so the header does not
	   jump down on a full page load. See epics-overview.component.module.css. */
	margin-block-start: calc(-1 * var(--spacing-5) - 1px);

	/* Mirror the band's tighter mobile tier1 padding so the header lines up there too. */
	@media (width <= 640px) {
		padding-block-start: var(--spacing-3);
		margin-block-start: calc(-1 * var(--spacing-4) - 1px);
	}
}
